import HeaderInner from "../comp/head-navs-inner";
import ViewContentSmall from "../comp/view-content-sm";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import VaultDocsCheckModule from "../comp/vault-docs-check";

export default function DocsCheck() {

  return (
    <>
      <HeaderInner name={'Check Credential'} link={'/vault'}/>
      <ViewContentSmall 
        content={
          <>
            <ViewDividerSmall />
            <VaultDocsCheckModule />

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
    </>
  )
}